export default __webpack_public_path__ + "static/media/vox-img-legacy-004.ffbf1e66.jpg";